import React, { useMemo } from "react";

import { MapProps } from "./map.model";
import { useI18nStore } from "@companion-core/shared/app/Store/i18nStore";

export const Map = ({ beginningAddress, endingAddress, APIKey, className }: MapProps) => {
  const locale = useI18nStore.getState().locale;
  const url = useMemo(() => {
    if (endingAddress) {
      return `https://www.google.com/maps/embed/v1/directions?key=${APIKey}&language=${locale}&origin=${beginningAddress.formatted_address}&destination=${endingAddress.formatted_address}`;
    } else {
      return `https://www.google.com/maps/embed/v1/place?key=${APIKey}&language=${locale}&q=${beginningAddress.formatted_address}`;
    }
  }, [beginningAddress, endingAddress, locale]);

  return (
    <iframe
      src={url}
      className={className}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
};
